import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, withStyles } from '@material-ui/core';
import styles from './suggested-match-cell.style';
import ScoreBadge from '../score-badge/score-badge';
import { QUEUE_STATUS } from '../../constants/lms-course-review.constants';
import { isResolvedReviewStatus } from '../../utils/lms-course-review.utils';

const isScoreOnlyDescription = (text) =>
  typeof text === 'string' && text.startsWith('Match score:');

const SuggestedMatchCell = ({ classes, item }) => {
  const suggestion = item?.suggestedResource;
  if (!suggestion?.resourceKey) {
    return (
      <Typography variant="body2" color="textSecondary" data-testid="suggested-match-empty">
        —
      </Typography>
    );
  }

  const isResolved =
    item.status === QUEUE_STATUS.RESOLVED || isResolvedReviewStatus(item.reviewStatus);
  const hasMeaningfulScore = suggestion.score != null && suggestion.score > 0;
  const showScoreBadge = hasMeaningfulScore && !isResolved;
  const showManualLinkLabel = isResolved && !hasMeaningfulScore;
  const resourceKey = suggestion.resourceKey;
  const showResourceKey = !isResolved && resourceKey != null;
  const secondaryText =
    suggestion.description && !(isResolved && isScoreOnlyDescription(suggestion.description))
      ? suggestion.description
      : null;

  return (
    <Box data-testid={`suggested-match-${item.id}`}>
      <Box display="flex" alignItems="center" flexWrap="wrap" className={classes.titleRow}>
        <Typography variant="body2" className={classes.name}>
          {suggestion.name}
        </Typography>
        {showScoreBadge ? (
          <Box marginLeft={1}>
            <ScoreBadge score={suggestion.score} />
          </Box>
        ) : null}
      </Box>
      {showResourceKey ? (
        <Typography variant="caption" color="textSecondary" className={classes.resourceKey}>
          Course ID: {resourceKey}
        </Typography>
      ) : null}
      {secondaryText ? (
        <Typography variant="caption" color="textSecondary" className={classes.description}>
          {secondaryText}
        </Typography>
      ) : null}
      {showManualLinkLabel ? (
        <Typography variant="caption" color="textSecondary" className={classes.manualLink}>
          Manually linked
        </Typography>
      ) : null}
    </Box>
  );
};

SuggestedMatchCell.propTypes = {
  item: PropTypes.object.isRequired,
};

export default withStyles(styles)(SuggestedMatchCell);
